import store from "../";

const state = {};

// getters
const getters = {};

// actions
const actions = {
  login(state, data) {
    store.commit("user/setToken", data.token);
    store.commit("user/setUser", data.user);
  }
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
